import { NO_ELEMENT } from 'utils';

interface TestComponentProps {
  param: string;
}

const isTestComponent = (props: unknown): props is TestComponentProps =>
  'param' in (props as TestComponentProps);

export const TestComponent = (props: unknown) => {
  if (!isTestComponent(props)) {
    return NO_ELEMENT;
  }

  return <div>{props.param}</div>;
};
